import { CustomProjectModel } from '@entities/CustomProject/CustomProjectModel';
import { ProjectOrderedQtyPayload } from '../../../Processes/Gateways/CustomProjects/Interfaces/ProjectItemOrderedQtyPayload';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';

export const CreateOrderedQtyPayloadForAllFragments = (
    parsedFragments: ParsedFragmentEntity[],
    customProject: CustomProjectModel
): ProjectOrderedQtyPayload[] => {
    return parsedFragments
        .flatMap(fragment => fragment.getOrderedQtyPayload())
        .map(payload => ({
            ...payload,
            template_index: 0,
            template_id: customProject.templates
                ? customProject.templates[0].id
                : 0,
        }));
};
